/* eslint-disable */
/* eslint-disable  prefer-template */
/* eslint-disable  no-else-return */
import _ from 'lodash';
import moment from 'moment';

export const imgPlaceHolder = (args, size = '200x200') => {
  const img = `http://via.placeholder.com/${size}?text=${args}`;
  return img;
};

export const insertUpdateObjectToList = (list = [], data = {}) => {
  const newList = list.map((item) => {
    if (data.id !== item.id) return item;
    return _.assign({}, item, data);
  });

  return newList;
};

export const isNumber = (number) => {
  if (_.isEmpty(`${number}`)) return true;
  // const regexp = /^[0-9]+([,.][0-9]+)?$/g;
  const regexp = /^[0-9.]*$/;
  return regexp.test(number);
};

export const omitEmptyArgs = (args) => {
  const newArgs = {};
  _.forEach(args, (value, key) => {
    if (!_.isEmpty(`${value}`) && !_.isNull(value)) {
      newArgs[key] = value;
      return newArgs;
    }
    return newArgs;
  });

  return newArgs;
};

export const numberWithCommas = (x = 0) => {
  const parts = x.toString().split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return parts.join('.');
};

export const customStyle = {
  input: (base) => ({
    ...base,
    fontSize: 12,
    height: 24,
  }),
  control: (base) => ({
    ...base,
    height: 33,
    minHeight: 33,
    fontWeight: 'bold',
  }),
  dropdownIndicator: (base) => ({
    ...base,
    paddingTop: 0,
    paddingBottom: 0,
  }),
  clearIndicator: (base) => ({
    ...base,
    paddingTop: 0,
    paddingBottom: 0,
  }),
};

export const reactSelectCustomStyle = {
  control: (base) => ({
    ...base,
    backgroundColor: 'none',
    minHeight: 36,
    border: 'none',
    boxShadow: 'none',
  }),
  dropdownIndicator: (base) => ({
    ...base,
    paddingTop: 0,
    paddingBottom: 0,
  }),
  clearIndicator: (base) => ({
    ...base,
    paddingTop: 0,
    paddingBottom: 0,
  }),
};

export const ucwords = (str) => {
  let val;
  val = `${str}`.replace(/^(.)|\s+(.)/g, ($1, val) => {
    return $1.toUpperCase();
  });
  return replaceValue(val)
}

export const replaceValue = (str) => {
  let newString = "";
  str.split(" ").map((data) => {
    if (data === "No") {
      data = data + '.';
    }
    if (data === "Of") {
      data = 'of';
    }
    newString = newString + " " + data
  });
  return newString
}

export const reactSelectCustomStyleCms = (data, containerItem) => ({
  control: (base, { isDisabled }) => ({
    ...base,
    backgroundColor: "none",
    backgroundColor: isDisabled ? 'rgba(239, 239, 239, 0.3)' : 'white',
    minHeight: 40,
    border: "none",
    boxShadow: "none",
    width: "100%",
  }),
  container: () => ({
    ...containerItem,
    border: `${containerItem?.border ? containerItem?.border : "1px solid #d9d9d9"}`, // border - temporary fix for border attributes
    minHeight: "43px !important",
    borderRadius: `${containerItem?.borderRadius ? containerItem?.borderRadius : "7px !important"}`, // borderRadius - temporary override borderRadius
    width: "100%",
  }),
  placeholder: (base, { isDisabled }) => ({
    color: isDisabled ? "#dedede" : "silver",
  }),
  dropdownIndicator: (base, { isDisabled }) => ({
    ...base,
    paddingTop: 0,
    paddingBottom: 0,
    color: isDisabled ? '#d9d9d9' : '#7790CB',
    clipPath: "polygon(50% 70%, 30%  35%, 70% 35%)",
    backgroundColor: isDisabled ? '#d9d9d9' : '#7790CB',
    cursor: "pointer",
  }),
  clearIndicator: (base) => ({
    ...base,
    paddingTop: 0,
    paddingBottom: 0,
    cursor: "pointer",
  }),
  // singleValue: () => ({
  //   color: "#4c6085",
  //   fontWeight: "bold",
  // }),
  menu: (base) => {
    return {
      ...base,
      zIndex: 1000,
    }
  },
  option: (base, act) => {
    return {
      ...base,
      zIndex: 1000,
      color: act.isSelected ? _.get(data, 'primary_color') : '#717171',
      backgroundColor: act.isFocused || act.isSelected ? _.get(data, 'primary_color_light') : 'transparent'
    }
  },
});

export const DataFormater = (number) => {
  if (number) {
    if (number > 1000000000) {
      return (number / 1000000000).toString() + 'B';
    } else if (number > 1000000) {
      return (number / 1000000).toString() + 'M';
    } else if (number > 1000) {
      return (number / 1000).toString() + 'K';
    } else {
      return number.toString();
    }
  }
  return number;
};

export const formatedSelectOption = (
  list = [],
  value = 'id',
  label = 'name',
  isToUpperCase = true
) => {
  const newData = [];
  list.forEach((item) => {
    newData.push({
      value: _.get(item, `${value}`),
      label: isToUpperCase
        ? _.get(item, `attributes.${label}`).toUpperCase()
        : _.get(item, `attributes.${label}`),
      data: { ...item },
    });
  });
  return newData;
};

export const abbreviateThousands = (value) => {
  const num = Number(value);
  const absNum = Math.abs(num);
  const sign = Math.sign(num);
  const numLength = Math.round(absNum).toString().length;
  const symbol = ['K', 'M', 'B', 'T', 'Q'];
  const symbolIndex = Math.floor((numLength - 1) / 3) - 1;
  const abbrv = symbol[symbolIndex] || symbol[symbol.length - 1];
  let divisor = 0;
  if (numLength > 15) divisor = 1e15;
  else if (numLength > 12) divisor = 1e12;
  else if (numLength > 9) divisor = 1e9;
  else if (numLength > 6) divisor = 1e6;
  else if (numLength > 3) divisor = 1e3;
  else return num;
  return `${((sign * absNum) / divisor).toFixed(divisor && 1)}${abbrv}`;
};

export const formatNumber = (no) => {
  const firstTwo = no.substring(0, 2);
  if (firstTwo === '09') {
    return no.replace(/^.{2}/g, '639');
  }

  return no;
};


export const numberFormat = (value, decimal_place) => {
  return Number((value === "0" || !value ? "0.00" : value)).toLocaleString(undefined, {
    minimumFractionDigits: decimal_place,
    maximumFractionDigits: decimal_place,
  })
}

export const subDays = (count) => {
  const d = new Date();
  const final = new Date(d.setDate(d.getDate() - count));
  return final;
};

// format date to YYYY-MM-DD
export const formatDate = (date) => {
  const d = new Date(date);
  let month = `${d.getMonth() + 1}`;
  let day = `${d.getDate()}`;
  const year = d.getFullYear();

  if (month.length < 2) month = `0${month}`;
  if (day.length < 2) day = `0${day}`;

  return [year, month, day].join('-');
}

// get year form any date format
export const getYear = (date = "") => {
  const d = new Date(date);
  const year = d.getFullYear()
  return year
}

// add suffix to numbers, ex. 1st, 2nd, 3rd
export const ordinalSuffixFormatter = num => {
  const a = +num % 10,
    b = +num % 100;
  if (a === 1 && b !== 11) return `${num}st`
  if (a === 2 && b !== 12) return `${num}nd`
  if (a === 3 && b !== 13) return `${num}rd`
  return `${num}th`;
}

/**
 * 
 * @param {*} str 
 * @returns  string: returns Title Case ex. the avengers => The Avengers
 */
export const convertToTitleCase = str => {
  if (typeof str === 'string' && (!_.isNull(str) || !_.isUndefined(str))) return _.startCase(_.toLower(str));
  return str
}

// check similarities in string value: ex. "Smart City" === "city" : true since both have the word 'city'
export const checkCommonStringValue = (value1 = "", value2 = "") => {
  const pattern = new RegExp(value1, "i")

  if (pattern.test(value2)) return true
  return false
}

// check if value of key in an object is a string alphabet
const uc = d => d >= 'a' && d <= 'z' ? String.fromCharCode(d.charCodeAt() - 32) : d

// convert strings in obj to uppercase
export const toUpperCaseAll = (key, value) => typeof value === 'string' ? Array.from(value, uc).join('') : value

export const EXTENSION_NAMES = [
  { label: 'N/A', value: '' },
  { label: 'JR.', value: 'JR.' },
  { label: 'SR.', value: 'SR.' },
  { label: 'II', value: 'II' },
  { label: 'III', value: 'III' },
  { label: 'IV', value: 'IV' },
  { label: 'V', value: 'V' },
  { label: 'VI', value: 'VI' },
  { label: 'VII', value: 'VII' },
  { label: 'VIII', value: 'VIII' },
  { label: 'IX', value: 'IX' },
  { label: 'X', value: 'X' },
];

export const formatMobileNumber = (mobile_number) => {
  let val = '';
  if (mobile_number.substring(0, 1) === '6') {
    val = mobile_number.replace('639', '+639');
  }
  else if (mobile_number.substring(0, 1) === '+') {
    val = mobile_number;
  }
  return val;
};

export const STATUS_OPTIONS = [
  { label: 'N/A', value: '' },
  { label: 'SINGLE', value: 'SINGLE' },
  { label: 'PARTNERSHIP', value: 'PARTNERSHIP' },
  { label: 'CORPORATION', value: 'CORPORATION' },
];

export const backSuffix = (n) => {
  const numVal = n.substring(0, 1);
  return numVal;
}

export const formatNumberWithCommas = value => {
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export const quarterList = [
  { label: '1ST QUARTER', value: '1' },
  { label: '2ND QUARTER', value: '2' },
  { label: '3RD QUARTER', value: '3' },
  { label: '4TH QUARTER', value: '4' },
];

export const years = _.range(
  +moment().format('YYYY'),
  +moment().format('YYYY') + 2
).sort((a, b) => b - a);